var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PaymentForm',{attrs:{"on-cancel":_vm.onCancel,"on-pay":_vm.onPay,"pay-button-text":_vm.payButtonText}})
}
var staticRenderFns = []

export { render, staticRenderFns }